import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PanelBasicBlock}
 */
const PanelBasic = ({
    backgroundColor,
    buttons,
    richText,
    title
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`col-wrapper-breakout ${bgColor} rounded-lg pt-24 pb-16`}>
            <div className='col-padding'>
                <h2 className='type-style-sans-h1 w-full md:w-7/12'>
                    {title}
                </h2>

                {richText && (
                    <div
                        className='rich-text type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'
                        dangerouslySetInnerHTML={{ __html: richText}} />
                )}

                {buttons?.length > 0 && (
                    <div className='mt-24 sm:mt-40 flex flex-wrap gap-x-8'>
                        {buttons.map((button, idx) => {
                            const isCtaLinkLocal = isLocalURL(formatLinkBlockToUrl(button.ctaLink));

                            return (
                                <React.Fragment key={idx}>
                                    {button.ctaMobileUrlOverride ? (
                                        <>
                                            <a
                                                className={`sm:hidden ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}`}
                                                href={button.ctaMobileUrlOverride}
                                                rel='noreferrer'
                                                target='_blank'>
                                                {button.ctaLabel}
                                            </a>
                                            <a
                                                className={`hidden sm:inline-block ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                                href={formatLinkBlockToUrl(button.ctaLink)}
                                                rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                                target={isCtaLinkLocal ? undefined : '_blank' }>
                                                {button.ctaLabel}
                                            </a>
                                        </>
                                    ) : (
                                        <a
                                            className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                            href={formatLinkBlockToUrl(button.ctaLink)}
                                            rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                            target={isCtaLinkLocal ? undefined : '_blank' }>
                                            {button.ctaLabel}
                                        </a>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PanelBasic;
